import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { Device, DeviceState, DeviceFirmware } from './types';

export const actions: ActionTree<DeviceState, RootState> = {
  getDevices({ commit }): any {
    axios({
      url: '/api/v1/devices',
    }).then(
      (response: AxiosResponse) => {
        const payload: Device[] = response && response.data;
        commit('GET_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('GET_ERROR', payload);
      },
    );
  },
  connectDevice({ commit, state }, device: Device): any {
    if (
      device &&
      device.adConnectDevice &&
      Array.isArray(device.adConnectDevice.expose)
    ) {
      let service: string = 'http';
      if (device.adConnectDevice.expose.indexOf('https') > -1) {
        service = 'https';
      }

      axios({
        url: `/api/v1/devices/${device.adConnectDevice!.id}/connect/${service}`,
        method: 'GET',
        data: {},
      }).then(
        (response: AxiosResponse) => {
          commit('CONNECT_DEVICE_SUCCESS', response.data);
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('CONNECT_DEVICE_ERROR', payload);
        },
      );
    } else {
      commit('CONNECT_DEVICE_ERROR', { status: 500 });
    }
  },
  rebootDevice({ commit, state }, device: Device): any {
    axios({
      url: `/api/v1/devices/${device._id!}/reboot`,
      method: 'POST',
      data: {},
    }).then(
      (response: AxiosResponse) => {
        commit('REBOOT_SUCCESS');
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('REBOOT_ERROR', payload);
      },
    );
  },
  updateFirmware({ commit, state }, deviceFirmware: DeviceFirmware): any {
    axios({
      url: `/api/v1/devices/${deviceFirmware.device._id!}/update/${
        deviceFirmware.firmware
      }`,
      method: 'POST',
      data: {},
    }).then(
      (response: AxiosResponse) => {
        commit('UPDATE_FIRMWARE_SUCCESS');
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('UPDATE_FIRMWARE_ERROR', payload);
      },
    );
  },
  updateDeviceActivation({ commit, state }, device: Device): any {
    axios({
      url: `/api/v1/devices/${device._id!}`,
      method: 'PUT',
      data: { activated: device.activated },
    }).then(
      (response: AxiosResponse) => {
        commit('UPDATE_SUCCESS');
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('UPDATE_ERROR', payload);
      },
    );
  },
};
